import type { ReactNode } from 'react';

interface Props {
  children: ReactNode;
  /** Centra el contenido verticalmente (login, estados vacios). */
  centrado?: boolean;
  /** Bloque de acciones ancladas a la zona del pulgar. */
  acciones?: ReactNode;
}

export function Screen({ children, centrado, acciones }: Props) {
  return (
    <main
      className={[
        'min-h-dvh w-full bg-fondo px-4 pt-6 sm:px-6',
        acciones ? 'pb-28' : 'pb-6',
        centrado && 'flex flex-col items-center justify-center text-center',
      ]
        .filter(Boolean)
        .join(' ')}
    >
      <div className="mx-auto w-full max-w-md">{children}</div>
      {acciones && (
        <div
          className="fixed inset-x-0 bottom-0 z-20 border-t border-borde bg-fondo/95 px-4 py-3 backdrop-blur"
          style={{ paddingBottom: 'calc(env(safe-area-inset-bottom) + 0.75rem)' }}
        >
          <div className="mx-auto flex max-w-md gap-3">{acciones}</div>
        </div>
      )}
    </main>
  );
}
